import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template"]

  connect() {
    this.renumber()
  }

  add(event) {
    event.preventDefault()

    const content = this.templateTarget.innerHTML.replaceAll(
      "NEW_RECORD",
      new Date().getTime().toString()
    )

    this.containerTarget.insertAdjacentHTML("beforeend", content)

    const newItem = this.containerTarget.querySelector(
      "[data-nested-form-item]:last-child"
    )

    this.renumber()
    this.focusNewItem(newItem)
  }

  remove(event) {
    event.preventDefault()

    const wrapper = event.target.closest("[data-nested-form-item]")
    if (!wrapper) return

    const destroyInput = wrapper.querySelector("input[name*='[_destroy]']")

    if (destroyInput) {
      destroyInput.value = "1"
      wrapper.classList.add("hidden")
    } else {
      wrapper.remove()
    }

    this.renumber()
  }

  renumber() {
    const visibleItems = this.containerTarget.querySelectorAll(
      "[data-nested-form-item]:not(.hidden)"
    )

    visibleItems.forEach((item, index) => {
      const number = item.querySelector("[data-nested-form-number]")
      const positionInput = item.querySelector("input[name*='[position]']")

      if (number) number.textContent = `${index + 1}.`
      if (positionInput) positionInput.value = index + 1
    })
  }

  focusNewItem(item) {
    if (!item) return

    item.scrollIntoView({
      behavior: "smooth",
      block: "center"
    })

    const focusTarget =
      item.querySelector("[data-nested-form-focus]") ||
      item.querySelector("input:not([type='hidden']), textarea")

    if (focusTarget) {
      setTimeout(() => focusTarget.focus(), 250)
    }
  }
}